import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router'
import { toast } from '@/components/feedback/toast-store'
import { PageHeader } from '@/components/ui/PageHeader'
import { useAdmitStudent } from '@/features/students/api'
import { StudentForm } from '@/features/students/components/StudentForm'
import { emptyGuardian } from '@/features/students/schemas'
import { toPayload } from '@/features/students/mappers'
import { useDocumentTitle } from '@/hooks/useDocumentTitle'

export function StudentAdmitPage() {
  const { t } = useTranslation('students')
  useDocumentTitle('Admit a student')
  const navigate = useNavigate()
  const admit = useAdmitStudent()
  const today = new Date().toISOString().slice(0, 10)

  return (
    <>
      <PageHeader
        title={t('Admit a student')}
        description={t(
          'Create the student record, place them in a section of the current academic year and add their guardians.',
        )}
        breadcrumbs={[{ label: t('Students'), to: '/admin/students' }, { label: t('Admit') }]}
        homeHref="/admin"
      />
      <StudentForm
        mode="admit"
        submitLabel={t('Admit student')}
        defaultValues={{
          admissionNumber: '',
          firstName: '',
          lastName: '',
          gender: 'female',
          dateOfBirth: '',
          bloodGroup: '',
          religion: '',
          nationality: '',
          email: '',
          phone: '',
          address: '',
          medicalNotes: '',
          photoFileId: null,
          guardians: [{ ...emptyGuardian, isPrimary: true }],
          classId: '',
          sectionId: '',
          rollNumber: '',
          admissionDate: today,
        }}
        onCancel={() => void navigate('/admin/students')}
        onSubmit={async (values) => {
          const student = await admit.mutateAsync({
            ...toPayload(values),
            sectionId: Number(values.sectionId),
            rollNumber: values.rollNumber,
            admissionDate: values.admissionDate,
          })
          toast.success(t('Student admitted'), `${student.summary.fullName} · ${student.summary.studentCode}`)
          void navigate(`/admin/students/${student.summary.id}`)
        }}
      />
    </>
  )
}
